<script>


import TableAnnidata from "@/views/RefAziendale/TabellaAnnidata/TableAnnidata.vue";

export default {
  name: "PadreTabellaAnnidata",
  data (){
    return {
      id : 0
    }
  },
  components: {
    TableAnnidata
  },
  props: {
    childRow: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    getParentRow: {
      type: Function,
      required: true
    },
    downloadReport: {
      type: Function,
      required: true
    },
  },
  created () {
    this.id = String(Math.floor(Math.random() * 10001));
  }

}
</script>

<template>
  <b-card body-class="p-2">
    <strong>Piano Padre</strong>
      <b-table :id="id" v-if="getParentRow(childRow)" small bordered striped :items="[getParentRow(childRow)]" :fields="fields" responsive primary-key="wpw_id">
        <template #cell(link)="data">
          <span class="text-info link_property" style="cursor: pointer" @click="downloadReport(data.item.wpw_id)" >Scarica file</span>
        </template>

        <template #cell(index)="data">
          <span >{{data.index}}</span>
        </template>

        <template #cell(wpw_id)="row">
          <TableAnnidata :row="row"/>
        </template>

          <template #row-details="row">
            <PadreTabellaAnnidata :childRow="row.item" :fields="fields" :getParentRow="getParentRow" :downloadReport="downloadReport" />
          </template>
      </b-table>
    <div v-else>
      <p>No parent found</p>
    </div>
   </b-card>
 </template>

 <style scoped>
 .link_property:hover {
   text-decoration: underline;
 }
 </style>